import React, { Component } from 'react';
import { Card, CardHeader, Modal, CardBody } from 'reactstrap';
import ImportSubscribersForm from '../../../components/ImportSubscribersForm';

class ImportSubscribersModal extends Component {
  render() {
    const { isOpened, submit, close } = this.props;

    return (
      <Modal
        zIndex={1000}
        className="modal-dialog-centered"
        isOpen={isOpened}
        toggle={() => close()}
      >
        <div className="modal-body p-0">
          <Card className="bg-secondary shadow border-0 mb-0">
            <CardHeader className="bg-transparent position-relative">
              <div className="text-muted text-center mt-2 mb-2">
                <p>Import</p>
              </div>
              <a
                href="/"
                onClick={e => {
                  e.preventDefault();
                  close();
                }}
                className="position-absolute right-4 top-4 display-4"
              >
                <i className="ni ni-fat-remove text-default" />
              </a>
            </CardHeader>
            <CardBody className="px-lg-5">
              <ImportSubscribersForm onSubmit={submit} />
            </CardBody>
          </Card>
        </div>
      </Modal>
    );
  }
}

export default ImportSubscribersModal;
